<template>
  <div id="app" class="box">
    <Top v-if="whiteName.indexOf(routeName)==-1" />
    <!-- <Nav v-if="routeName != 'visualization'" /> -->
    <router-view />
    <BtmFooter v-if="whiteName.indexOf(routeName)==-1" />
  </div>
</template>

<script>
import Top from "./components/top";
import Nav from "./components/nav-head";
import BtmFooter from "./components/btm-footer";
export default {
  created(){
    this.routeName = this.$route.name;
  },
  updated() {
    this.routeName = this.$route.name;
  },
  name: "App",
  data() {
    return {
      routeName: "",
      whiteName:['visualization','login'],
    };
  },
  components: {
    Top,
    Nav,
    BtmFooter,
  },
};
</script>

<style>
@import "./assets/css/main.css";
</style>

<style lang="less">
#app {
  min-height: 100%;
  font-family: PingFangSC-Regular, sans-serif, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  line-height: normal;
}
.container {
  width: 1200px;
  margin: 0 auto;
}

.fr {
  float: right;
}

.fl {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue